import script from "./pwaStatusPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./pwaStatusPopup.vue?vue&type=script&setup=true&lang=ts"

import "./pwaStatusPopup.vue?vue&type=style&index=0&id=6bf0101c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bf0101c"]])

export default __exports__